class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
    this.checkoutBtn = this.querySelector(".checkout-btn");
  }

  connectedCallback() {
    this.checkoutBtn.addEventListener("click", this.checkout.bind(this));
  }

  disconnectedCallback() {
    this.checkoutBtn.removeEventListener("click", this.checkout);
  }

  checkout(e) {
    e.preventDefault();
    document.querySelector("#checkout").click();
  }

  open() {
    this.notification.classList.add("animate", "active");
    this.classList.add("notification-active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    this.querySelector("#cart-notification-button").addEventListener(
      "click",
      this.openCartDrawer.bind(this)
    );
  }

  close() {
    this.notification.classList.remove("active");
    this.classList.remove("notification-active");

    removeTrapFocus(this.activeElement);
  }

  openCartDrawer() {
    const header = document.querySelector("custom-header");
    header.showHeader();
    setTimeout(function () {
      const cartBtn = document.querySelector('.nav-icons > a[data-id="cart"]');
      if (window.innerWidth < 1024) cartBtn.click();
      else cartBtn.dispatchEvent(new Event("mouseenter"))
    }, 100);
    this.close();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    document.querySelector("cart-items").classList.remove("is-empty");
    document.querySelector("#main-cart-footer").classList.remove("is-empty");

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        section: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
        section: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
      {
        id: "main-cart-items",
        section: "main-cart-items",
        selector: ".cart-items.js-contents",
      },
      {
        id: "main-cart-footer",
        section: "main-cart-footer",
        selector: "#main-cart-footer",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
